import { defineRecipe } from '@chakra-ui/react';

export const textRecipe = defineRecipe({
	base: {
		color:     '#444444',
		textStyle: 'body',
	},
	variants: {
		variant: {
			formLabel: {
				borderLeftColor: '#027FC3',
				borderLeftWidth: '4px',
				color:           '#444444',
				fontSize:        '16px',
				fontWeight:      'bold',
				lineHeight:      '24px',
				paddingLeft:     '8px',
			},
		},
	},
});
